import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const BoxBtn = lib.styled.div`
  width: 26px;
  height: 26px;
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  margin: 15px 15px;

  .icon {
    div {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
